import * as ambassadorWixBillingV1TaxGroup from './billing-v1-tax-group-tax-groups.http.js';
import * as ambassadorWixBillingV1TaxGroupTypes from './billing-v1-tax-group-tax-groups.types.js';
import * as ambassadorWixBillingV1TaxGroupUniversalTypes from './billing-v1-tax-group-tax-groups.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createTaxGroup(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingV1TaxGroupUniversalTypes.CreateTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupTypes.CreateTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.CreateTaxGroupResponse &
    ambassadorWixBillingV1TaxGroupUniversalTypes.CreateTaxGroupResponseNonNullableFields,
  ambassadorWixBillingV1TaxGroupTypes.CreateTaxGroupResponse &
    ambassadorWixBillingV1TaxGroupTypes.CreateTaxGroupResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxGroup.createTaxGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tax-groups',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getTaxGroup(): __PublicMethodMetaInfo<
  'GET',
  { taxGroupId: string },
  ambassadorWixBillingV1TaxGroupUniversalTypes.GetTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupTypes.GetTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.GetTaxGroupResponse &
    ambassadorWixBillingV1TaxGroupUniversalTypes.GetTaxGroupResponseNonNullableFields,
  ambassadorWixBillingV1TaxGroupTypes.GetTaxGroupResponse &
    ambassadorWixBillingV1TaxGroupTypes.GetTaxGroupResponseNonNullableFields
> {
  const payload = { taxGroupId: ':taxGroupId' } as any;

  const getRequestOptions = ambassadorWixBillingV1TaxGroup.getTaxGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/tax-groups/{taxGroupId}',
    pathParams: { taxGroupId: 'taxGroupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateTaxGroup(): __PublicMethodMetaInfo<
  'PATCH',
  { taxGroupId: string },
  ambassadorWixBillingV1TaxGroupUniversalTypes.UpdateTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupTypes.UpdateTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.UpdateTaxGroupResponse &
    ambassadorWixBillingV1TaxGroupUniversalTypes.UpdateTaxGroupResponseNonNullableFields,
  ambassadorWixBillingV1TaxGroupTypes.UpdateTaxGroupResponse &
    ambassadorWixBillingV1TaxGroupTypes.UpdateTaxGroupResponseNonNullableFields
> {
  const payload = { taxGroup: { id: ':taxGroupId' } } as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxGroup.updateTaxGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/tax-groups/{taxGroup.id}',
    pathParams: { taxGroupId: 'taxGroupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteTaxGroup(): __PublicMethodMetaInfo<
  'DELETE',
  { taxGroupId: string },
  ambassadorWixBillingV1TaxGroupUniversalTypes.DeleteTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupTypes.DeleteTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.DeleteTaxGroupResponse,
  ambassadorWixBillingV1TaxGroupTypes.DeleteTaxGroupResponse
> {
  const payload = { taxGroupId: ':taxGroupId' } as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxGroup.deleteTaxGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/tax-groups/{taxGroupId}',
    pathParams: { taxGroupId: 'taxGroupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryTaxGroups(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingV1TaxGroupUniversalTypes.QueryTaxGroupsRequest,
  ambassadorWixBillingV1TaxGroupTypes.QueryTaxGroupsRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.QueryTaxGroupsResponse &
    ambassadorWixBillingV1TaxGroupUniversalTypes.QueryTaxGroupsResponseNonNullableFields,
  ambassadorWixBillingV1TaxGroupTypes.QueryTaxGroupsResponse &
    ambassadorWixBillingV1TaxGroupTypes.QueryTaxGroupsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxGroup.queryTaxGroups(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tax-groups/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDefaultTaxGroups(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBillingV1TaxGroupUniversalTypes.ListDefaultTaxGroupsRequest,
  ambassadorWixBillingV1TaxGroupTypes.ListDefaultTaxGroupsRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.ListDefaultTaxGroupsResponse &
    ambassadorWixBillingV1TaxGroupUniversalTypes.ListDefaultTaxGroupsResponseNonNullableFields,
  ambassadorWixBillingV1TaxGroupTypes.ListDefaultTaxGroupsResponse &
    ambassadorWixBillingV1TaxGroupTypes.ListDefaultTaxGroupsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxGroup.listDefaultTaxGroups(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/tax-groups/default-tax-groups',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDefaultTaxGroupsByAppIds(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingV1TaxGroupUniversalTypes.ListDefaultTaxGroupsByAppIdsRequest,
  ambassadorWixBillingV1TaxGroupTypes.ListDefaultTaxGroupsByAppIdsRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.ListDefaultTaxGroupsByAppIdsResponse &
    ambassadorWixBillingV1TaxGroupUniversalTypes.ListDefaultTaxGroupsByAppIdsResponseNonNullableFields,
  ambassadorWixBillingV1TaxGroupTypes.ListDefaultTaxGroupsByAppIdsResponse &
    ambassadorWixBillingV1TaxGroupTypes.ListDefaultTaxGroupsByAppIdsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxGroup.listDefaultTaxGroupsByAppIds(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tax-groups/list-default-tax-groups-by-app-ids',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
